import './Spinner.css';

export default function Spinner() {
  return (
    <div className="custom-loader"></div>
  );
}
